import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import FilledInput from '@material-ui/core/FilledInput';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {},
  inputRoot: {
    backgroundColor: '#fff',
    border: '1px solid #e2e2e1',
    borderRadius: '4px',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, '
    + 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#fff',
      borderColor: '#a0a0a0',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
    '&.Mui-disabled': {
      backgroundColor: '#fff',
    },
    '&.Mui-error': {
      borderColor: '#dc3545',
      boxShadow: '0 0 0 0.2rem rgba(220,53,69,.25)',
    },
  },
  inputLabelRoot: {
    '&.Mui-focused': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    '&.Mui-error': {
      color: '#f44336 !important',
    },
  },
};

const commonDefaultInputProps = {
  autoCapitalize: 'off',
};

class PasswordTextField extends Component {
  state = {
    showPassword: false,
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  }

  render() {
    const {
      id,
      value,
      label,
      onChange,
      error,
      helperText,
      disabled,
      classes,
      margin,
    } = this.props;

    return (
      <FormControl
        className={classes.root}
        variant="filled"
        disabled={disabled}
        fullWidth
        margin={margin || 'normal'}
        error={Boolean(error)}
      >
        <InputLabel
          htmlFor={id}
          className={classes.inputLabelRoot}>
            {label}
          </InputLabel>
          <FilledInput
            id={id}
            type={this.state.showPassword ? 'text' : 'password'}
            value={value}
            onChange={onChange}
            disableUnderline={true}
            className={classes.inputRoot}
            inputProps={commonDefaultInputProps}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  onMouseDown={e => e.preventDefault()}
                  edge="end"
                  disabled={disabled}
                >
                  {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            />
          {helperText ? (
            <FormHelperText id="component-error-text">
              {helperText}
            </FormHelperText>
          ) : null}
      </FormControl>
    );
  }
}

PasswordTextField.propTypes = {
  id: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(PasswordTextField);
